// LinkedIn Icon:

import React from 'react'

const Bag = () => (
  <svg version="1.1" width="100%" viewBox="0 0 24.46 29.12">
    <path
      fill="none"
      strokeMiterlimit="10"
      strokeWidth="2px"
      d="M8.39,5.18v-3L9.65,1h5.16l1.26,1.18v3m7.39,22.94H1v-21H23.46Z"
    />
  </svg>
)

export default Bag
